import { graphql } from 'gatsby'
import React from 'react'

import Image from '@/components/image/image'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'

import * as cardStyles from './content-image.module.scss'

const ContentImage: React.FC<Queries.DatoCmsContentImage> = ({
  title,
  content,
  image,
  display
}) => {
  return (
    <div className={`col-lg-${display} ${cardStyles.card}`}>
      <div>
        <Image image={image} />
      </div>
      <div className="px-4 pt-4 pb-1">
        <h3 className=" pt-3 pr-3 pb-2">{title}</h3>
        {content && <StructuredTextDefault content={content} />}
      </div>
    </div>
  )
}

export default ContentImage

export const query = graphql`
  fragment SectionContentImage on DatoCmsContentImage {
    __typename
    id
    display
    title
    content {
      value
      links
    }
    image {
      url
      alt
      gatsbyImageData
    }
  }
`
